import React from "react";

import { ImageProps } from "types";
import * as Image from "@components/image/index";
import * as Timestamp from "@components/timestamp/index";
import { Tracker } from "@util/tracker";
import { TDateISO } from "types/date";

import styles from "./styles.module.css";

export const enum ImageAlignment {
  left = "left",
  right = "right",
}
// TODO: This type is incorrectly shared by all the components
type Props = {
  text?: string;
  description?: string;
  url?: string;
  image?: ImageProps;
  // Both image and timestamp are optional
  // But timestamp will not render when image is also provided
  timestamp?: TDateISO;
};

function StyledText<T extends Props>(props: T) {
  const { text, url } = props;

  const tracker = Tracker.getInstance();

  if (url) {
    return (
      <a className={styles.text} href={url} ref={tracker.registerTracking}>
        {text}
      </a>
    );
  }

  return <span className={styles.text}>{text}</span>;
}

const StyledDescription = <T extends Props>(props: T) => (
  <div className={styles.description}>{props.description}</div>
);

const StyledTimestamp = <T extends Props>(props: T) => (
  <div className={styles.timestamp}>
    <Timestamp.Component timestamp={props.timestamp} />
  </div>
);

const StyledImage = <T extends Props>(props: T) => (
  <Image.Component
    mobileMaxWidth={72}
    desktopMaxWidth={72}
    aspectRatio={1}
    {...props.image}
  />
);

export {
  StyledDescription as Description,
  StyledImage as Image,
  StyledText as Text,
  StyledTimestamp as Timestamp,
  Props,
};
